import { useQueries } from '@tanstack/react-query'
import { useDefaultOrganizationId } from '../organizations/useDefaultOrganizationId.ts'
import { createCheckoutUrl } from '@/services/Firebase'
import { useFetchProducts } from './useFetchProducts.ts'
import { useCurrentSubscription } from '../organizations/useCurrentSubscription.ts'

export function useFetchCheckoutUrl() {
  const organizationId = useDefaultOrganizationId()
  const currentSubscription = useCurrentSubscription()
  const products = useFetchProducts()

  const queries = useQueries({
    queries: !products.isSuccess
      ? []
      : products.data.map(product => ({
          queryKey: ['checkout-url', organizationId, product.month.id, product.year.id],
          enabled: Boolean(products.isSuccess && organizationId && !currentSubscription),
          staleTime: 1000 * 60 * 60 * 23, // refetch after 23h.
          queryFn: async () => {
            const monthly = await fetchCheckoutUrl(organizationId, product.month.id)
            const yearly = await fetchCheckoutUrl(organizationId, product.year.id)
            return {
              ...product,
              month: {
                ...product.month,
                url: monthly.url,
              },
              year: {
                ...product.year,
                url: yearly.url,
              },
            }
          },
        })),
  })

  return queries
}

async function fetchCheckoutUrl(organizationId: string, priceId: string) {
  const result = await createCheckoutUrl({
    organizationId,
    priceId,
    successUrl: window.location.href,
    cancelUrl: window.location.href,
  })
  return result.data
}
